import { z } from "zod"

import { measuresSchema } from "./baseline"
import { intervalInfoSchema } from "./interval-info"
import { profilePropertiesSchema } from "./profile-properties"
import { sourceSchema } from "./source"

export const productionProfileSchema = z.object({
  profileId: z.string(),
  providerProfileId: z.string(),
  profileName: z.string().optional(),
  accountId: z.string(),
  serviceTypes: z.literal(`SOLAR_PV`),
  source: sourceSchema,
  isDefault: z.boolean().optional(),
  dataStatus: z.number(),
  properties: profilePropertiesSchema.nullable(),
  intervals: z
    .object({
      totalCount: z.number(),
      pageCount: z.number(),
      pageStart: z.number(),
      list: z.array(intervalInfoSchema),
    })
    .optional(),
  baselineMeasures: z.array(measuresSchema),
})

export type ProductionProfile = z.infer<typeof productionProfileSchema>
